import { Component, inject } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AuthService } from '../../_core/auth.service';
import { Core } from '../../_core/core';
import { Metering } from '../../_core/metering';
import { Notification } from '../../_core/notification';
import { BillingService } from '../../_core/billings';
import { Settings } from '../../_core/settings';
import { HomeS } from '../../_core/home';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [DialogModule, ButtonModule],
  templateUrl: './logout.html',
  styleUrl: './logout.scss',
})
export class Logout {
  private $auth = inject(AuthService);
  private $core = inject(Core);
  private $notification = inject(Notification);
  private $home = inject(HomeS);
  private $settings = inject(Settings);
  private $metering = inject(Metering);
  private $billing = inject(BillingService);

  private ref = inject(DynamicDialogRef);

  public close(confirm: boolean): void {
    if (confirm) {
      this.$core.clear();
      this.$home.clear();
      this.$notification.clearNotifications();
      this.$settings.clear();
      this.$metering.clear();
      this.$billing.clear();
      this.$auth.removeAuthToken();
      this.ref.close(true);
    } else {
      this.ref.close(false);
    }
  }
}
